import { Menu, MenuProps } from '@mui/material';
import { ReactElement } from 'react';

import { AccountMenuContent } from './account-menu-content';

type AccountMenuProps = MenuProps;

export const AccountMenuDesktop = (props: AccountMenuProps): ReactElement => {
    const { ...menuProps } = props;

    return (
        <Menu
            {...menuProps}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            slotProps={{ paper: { sx: { width: 264, pb: 0.5 } } }}
            MenuListProps={{ sx: { p: 0 } }}
        >
            <AccountMenuContent onClose={props.onClose} />
        </Menu>
    );
};
